import api from "./axios";

export interface UserInfo {
  id: string;
  email: string;
  role: string;
  is_active: boolean;
  is_superuser: boolean;
  name?: string | null;
  surname?: string | null;
  physician_id?: string | null;
}

export async function login(email: string, password: string): Promise<string> {
  const formData = new URLSearchParams();
  formData.append("username", email);
  formData.append("password", password);

  const response = await api.post("/auth/jwt/login", formData, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data.access_token;
}

export async function getMe(): Promise<UserInfo> {
  const response = await api.get("/users/me");
  return response.data;
}
